<template>
  <v-container>
    <template>
      <v-stepper
        v-if="steps<maxSteps"
        v-model="steps"
        vertical
        elevation="0"
      >
        <!-- step 1 -->
        <v-stepper-step

          :complete="steps > 1"
          step="1"
          @click="steps>1?steps = 1:steps=steps"
        >
          Tipologia Ordine
          <small
            v-if="order?.clipon=='CLP'"
            class="mt-1"
          >Occhiale Montato + Clip-On rif:<b> {{ order.desrif }}</b></small>
          <small
            v-else-if="order?.monsmo=='M'"
            class="mt-1"
          >Occhiale Montato rif:<b> {{ order.desrif }}</b></small>
          <small
            v-else-if="order?.monsmo=='S'"
            class="mt-1"
          >Solo Lenti rif:<b> {{ order.desrif }}</b></small>

          <small
            v-else
            class="mt-1"
          > -- </small>
        </v-stepper-step>

        <v-stepper-content step="1">
          <procedure-step1
            :step="steps"
            @nextStep="nextStep"
            @prevStep="prevStep"
            @viewCarnet="viewCarnet"
          />
        </v-stepper-content>
        <!-- step 2 -->
        <v-stepper-step
          :complete="steps > 2"
          step="2"
          @click="steps>2?steps = 2:steps=steps"
        >
          Caratteristiche Lenti
          <small
            v-if="order.lens"
            class="mt-1"
          >
            {{ order.lens.grvlens.dx.name }}
          </small>
        </v-stepper-step>

        <v-stepper-content step="2">
          <procedure-step2
            :step="steps"
            @nextStep="nextStep"
            @prevStep="prevStep"
          />
        </v-stepper-content>
        <!-- step 3 -->
        <v-stepper-step
          v-if="order.monsmo !== '//S'"
          :complete="steps > 3"
          step="3"
          @click="steps>3?steps = 3:steps=steps"
        >
          Montatura
          <small>
            {{ order.model?.[0]?.marca }} {{ order.model?.[0]?.modello }}
          </small>
        </v-stepper-step>

        <v-stepper-content step="3">
          <procedure-step3
            :step="steps"
            @nextStep="nextStep"
            @prevStep="prevStep"
          />
        </v-stepper-content>
        <!-- step 4 -->
        <!--
        <v-stepper-step
          :complete="steps > 4"
          step="4"
          @click="steps>4?steps = 4:steps=steps"
        >
          Accessori
          <small
            class="mt-1"
          >
           xx
          </small>
        </v-stepper-step>
        <v-stepper-content step="4">
          <procedure-step4
            :step="steps"
            @nextStep="nextStep"
            @prevStep="prevStep"
          />
        </v-stepper-content> -->

        <!-- //step 5
        <v-stepper-step
          v-if="order.clipon === 'CLP'"
          :complete="steps > 5"
          step="5"
          @click="steps>5?steps = 5:steps=steps"
        >
          Clip-ON
          <small
            class="mt-1"
          />
        </v-stepper-step>
        <v-stepper-content step="5">
          <procedure-step5
            :step="steps"
            @nextStep="nextStep"
            @prevStep="prevStep"
          />
        </v-stepper-content>-->
      </v-stepper>

      <riepilogo
        v-if="steps==maxSteps"
        :step="steps"
        @nextStep="nextStep"
        @prevStep="prevStep"
        @stdOrder="$emit('stdOrder')"
      />
    </template>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import ProcedureStep1 from '@/views/Ordine/component/procedure/GRV/step1'
  import ProcedureStep2 from '@/views/Ordine/component/procedure/GRV/step2'
  import ProcedureStep3 from '@/views/Ordine/component/procedure/GRV/step3'
  // import ProcedureStep4 from '@/views/Ordine/component/procedure/GRV/step4'
  import Riepilogo from '@/views/Ordine/component/procedure/GRV/riepilogo'

  export default {
    name: 'Workflow',
    components: {
      ProcedureStep1,
      ProcedureStep2,
      ProcedureStep3,
      // ProcedureStep4,
      Riepilogo,
    },
    props: {
      carnet: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        steps: 1,
        maxSteps: 4,
      }
    },
    computed: {
      ...mapState(['auth', 'order']),
      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },

    },
    watch: {
      carnet (val) {
        if (val != null) {
          this.steporder.carnet = val
        }
      },
    },
    mounted () {
      if (this.order.step > 1) {
        this.steps = this.order.step
      }
    },
    destroyed () {

    },
    methods: {
      viewCarnet () {
        this.$emit('viewCarnet')
      },
      nextStep (step) {
        console.log('nextstep', step)
        this.steps = step
        this.$forceUpdate()
      },
      prevStep (step) {
        console.log('prevstep', step - 1)
        this.steps = step - 1
        if (step === 0) {
          this.$emit('clearLinea')
        }
      },
    },
  }
</script>
